<template>
  <div class="contact-page">
    <PageHeader
      title="联系我们"
      subtitle="随时与我们取得联系，我们期待您的反馈"
      :breadcrumbItems="[{ text: '首页', path: '/' }]"
      currentText="联系我们"
    />
   
    <div class="page-container">
      <div class="contact-content">
        <!-- 联系信息 -->
        <div class="contact-info" v-loading="load">
          <h2 class="section-title">联系方式</h2>
          <div class="info-list" v-html="content"></div>
         
          <!-- 社交媒体链接 -->
          <div class="social-links">
            <h3>关注我们</h3>
            <div class="social-icons">
              <a href="#" class="social-icon"><el-icon><UserFilled /></el-icon></a>
              <a href="#" class="social-icon"><el-icon><Promotion /></el-icon></a>
              <a href="#" class="social-icon"><el-icon><Check /></el-icon></a>
              <a href="#" class="social-icon"><el-icon><Goods /></el-icon></a>
            </div>
          </div>
          
        </div>
        
        <!-- 联系表单 -->
        <div class="contact-form-container">
          <h2 class="section-title">在线留言</h2>
          <p class="form-desc">如果您有任何问题或建议，请填写以下表单，我们会尽快回复您</p>
          <ContactForm />
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import ContactForm from '@/components/ContactForm.vue';
import { getConfigs } from '@/api/config';

export default {
  name: 'Touch',
  components: {
    PageHeader,
    ContactForm
  },
  metaInfo: {
    title: '联系我们'
  },
  setup() {
    const loading = ref(false);
    const content = ref('');
    const today = ref('');

    
    const init = async () => {
      loading.value = true;
      try {
        const res = await getConfigs('mall.aboutUs');
        if (res.data.data ) {
          content.value = res.data?.data.content;
          today.value = res.data?.data.updateTime || new Date().toISOString();
        }
      } catch (error) {
        console.error('获取失败:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      init();
    });

    return {
      content,
      today,
      loading
    };
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  padding-bottom: 60px;
  
  .contact-banner {
    height: 300px;
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;
    
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }
    
    .banner-content {
      position: relative;
      z-index: 2;
      text-align: center;
      color: #fff;
      
      h2 {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 15px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
      
      p {
        font-size: 18px;
        max-width: 600px;
        margin: 0 auto;
        opacity: 0.9;
      }
    }
  }
  
  .contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    margin-bottom: 60px;
    
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }
    
    .contact-info {
      .section-title {
        margin-bottom: 30px;
      }
      
      .info-list {
        margin-bottom: 40px;
        
        .info-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 25px;
          
          i {
            font-size: 24px;
            color: #409EFF;
            margin-right: 15px;
            margin-top: 5px;
          }
          
          .info-text {
            h3 {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              margin-bottom: 5px;
            }
            
            p {
              font-size: 15px;
              color: #666;
              margin: 0;
            }
          }
        }
      }
      
      .social-links {
        margin-bottom: 40px;
        
        h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }
        
        .social-icons {
          display: flex;
          gap: 15px;
          
          .social-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background-color: #f5f7fa;
            color: #409EFF;
            text-decoration: none;
            transition: all 0.3s ease;
            
            i {
              font-size: 20px;
            }
            
            &:hover {
              background-color: #409EFF;
              color: #fff;
              transform: translateY(-3px);
            }
          }
        }
      }
      
      .company-photos {
        h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }
        
        .photo-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
          
          .photo-item {
            border-radius: 8px;
            overflow: hidden;
            height: 140px;
            
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;
              
              &:hover {
                transform: scale(1.05);
              }
            }
          }
        }
      }
    }
    
    .contact-form-container {
      .section-title {
        margin-bottom: 15px;
      }
      
      .form-desc {
        font-size: 15px;
        color: #666;
        margin-bottom: 30px;
      }
    }
  }
  
  .faq-section {
    .section-title {
      margin-bottom: 15px;
      
      &.text-center {
        text-align: center;
      }
    }
    
    .section-desc {
      font-size: 15px;
      color: #666;
      margin-bottom: 30px;
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;
      
      &.text-center {
        text-align: center;
      }
    }
  }
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background-color: #409EFF;
  }
  
  &.text-center {
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.page-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
</style>